import Vue from 'vue';
import '../assets/css/visual-preview.css';
import html from '../templates/visual-square-preview.html';
import draggableService from './draggable-service';
import classes from './classes';
import geometry from './geometry';
import previewService from './preview-services';

export default Vue.component('visualPreviewSquare', {
  template: html,
  props: {
    photoUrl: {
      default: 'http://stickerpipe.com/static/img/ema.0158668.png'
    },
    startDownload: {
      required: true
    },
    size: {
      default() {
        return {
          width: 360,
          height: 640
        };
      }
    },
    faceLandmarks: {
      default() {
        return {
          eyes: [{x: 150, y: 197}, {x: 254, y: 194}],
          mouth: [{x: 162, y: 302}, {x: 237, y: 297}]
        };
      }
    },
    changeShape: {
      required: true
    },
    story: {
      required: true
    },
    changedType: {
      required: true
    },
    photoType: {
      required: true
    },
    photoTypeTrigger: {
      required: true
    },
    staticStampChanges: {
      required: true
    },
    refreshComponents: {
      required: true
    },
    framePositionChanged: {
      required: true
    }
  },
  data() {
    return {
      imageDensity: 'xxhdpi',
      eyesAndLipsMiddleware: {},
      middlewareIndex: null,
      scaleResizeAvailableIndex: null,
      scaleRotateEyesLipsControl: {},
      computedStamps: [],
      photoHeightAndWidth: {},
      draggableVariables: {
        selected: '',
        mouseX: '',
        mouseY: '',
        elemX: '',
        elemY: '',
        finalIndex: '',
        currentElementIndex: null
      },
      stampSquareIndex: null,
      scaleResizeStaticControl: {
        selected: '',
        mouseX: '',
        mouseY: '',
        elemX: '',
        elemY: '',
        finalIndex: '',
        currentElementIndex: null
      },
      faceFromServer: {
        eyes: {},
        mouth: {}
      },
      crossSize: 14,
      currentStampType: null,
      stampsRangesXY: {
        minimumValue: 0,
        middleValue: 60,
        maximumValue: 120
      },
      controlSideLength: 20,
      initialStampSideLength: 120,
      eventX: null,
      eventY: null,
      eventSelectStamp: null
    };
  },
  methods: {
    clickOnImage(event) {
      console.log('event ', event);
      this.scaleResizeAvailableIndex = null;
      this.currentStampType = null;
      this.eventSelectStamp = null;
      this.$emit('current-stamp-index', null);
    },
    // created duplicate func for eyes and lips
    startScaleResizeEyesLips(event, index, elem) {
      // console.log('mouseDownTest ', event);
      event.stopPropagation();
      draggableService.dragStartScaleResize(event, null, this.scaleRotateEyesLipsControl, null, this.$refs.container);
      // Find index for manipulations with story
      this.story.data.content.forEach((item, i, arr) => {
        if (item.pivot_id === elem.pivot_id) {
          this.stampSquareIndex = i;
          this.middlewareIndex = i;
        }
      });
      document.addEventListener('mousemove', this.moveScaleResizeEyesLips);
      document.onmouseup = this.dragDestroy;
    },
    // fixme: for eyes and lips
    moveScaleResizeEyesLips(event) {
      let that = this;
      draggableService.moveScaleResize(event, this.scaleRotateEyesLipsControl);
      let angleAndScale = previewService.scalingAndRotating(this.scaleRotateEyesLipsControl, this.stampsRangesXY);
      this.story.data.content[this.stampSquareIndex].rotation = angleAndScale.angle;
      if (angleAndScale.scale < 0.4) {
        angleAndScale.scale = 0.4;
      }
      this.story.data.content[this.stampSquareIndex].scale = angleAndScale.scale;
      if (this.story.data.content[this.stampSquareIndex].initialCoordinatesSquare && !this.story.data.content[this.stampSquareIndex].coordinates) {
        this.story.data.content[this.stampSquareIndex].coordinates = this.story.data.content[this.stampSquareIndex].initialCoordinatesSquare;
      }
      let deltaRotation = angleAndScale.angle - this.story.data.content[this.stampSquareIndex].initialRotationSquare;
      let deltaScale = angleAndScale.scale / this.story.data.content[this.stampSquareIndex].initialScaleSquare;
      this.story.data.content[this.stampSquareIndex].delta_scale = deltaScale;
      this.story.data.content[this.stampSquareIndex].delta_rotation = deltaRotation;
      this.computedStamps.forEach(function (eyesStamp) {
        if (eyesStamp.pivot_id === that.story.data.content[that.stampSquareIndex].pivot_id) {
          eyesStamp.scale = angleAndScale.scale;
          eyesStamp.rotate = -angleAndScale.angle;
          eyesStamp.controlScale = geometry.calculateScaleForControls(angleAndScale.scale, that.controlSideLength);
        }
      });
      this.story.data.content[this.stampSquareIndex].workingPreview = this.photoType;
    },
    startScaleResize(event, index, elem) {
      // console.log('mouseDownTest ', event);
      event.stopPropagation();
      draggableService.dragStartScaleResize(event, null, this.scaleResizeStaticControl, null, this.$refs.container);
      // Find index for manipulations with story
      this.story.data.content.forEach((item, i, arr) => {
        if (item.pivot_id === elem.pivot_id) {
          this.stampSquareIndex = i;
        }
      });
      // Get initial values for dots
      document.addEventListener('mousemove', this.moveScaleResize);
      document.onmouseup = this.dragDestroy;
    },
    // for static elements
    moveScaleResize(event) {
      let that = this;
      draggableService.moveScaleResize(event, this.scaleResizeStaticControl);
      let angleAndScale = previewService.scalingAndRotating(this.scaleResizeStaticControl, this.stampsRangesXY);
      this.story.data.content[this.stampSquareIndex].rotation = -angleAndScale.angle;
      if (angleAndScale.scale < 0.4) {
        angleAndScale.scale = 0.4;
      }
      this.story.data.content[this.stampSquareIndex].scale = angleAndScale.scale;
      that.computedStamps.forEach(function (staticStamp) {
        if (staticStamp.pivot_id === that.story.data.content[that.stampSquareIndex].pivot_id) {
          that.story.data.content[that.stampSquareIndex].rotation = -angleAndScale.angle;
          that.story.data.content[that.stampSquareIndex].scale = angleAndScale.scale;
          staticStamp.scale = angleAndScale.scale;
          staticStamp.rotate = -angleAndScale.angle;
          staticStamp.controlScale = geometry.calculateScaleForControls(angleAndScale.scale, that.controlSideLength);
        }
      });
      that.$emit('static-stamp-changes', {
        rotate: -angleAndScale.angle,
        scale: angleAndScale.scale,
        pivot_id: that.story.data.content[that.stampSquareIndex].pivot_id
      });
    },
    // // New logic for eyes and lips
    dragStartEyesLips(e, index, elem, currentElemIndex) {
      let maxOrder = null;
      let currentOrder = null;
      draggableService.dragStart(e, index, this.draggableVariables, currentElemIndex);
      document.addEventListener('mousemove', this.moveEyesLips);
      document.onmouseup = this.dragDestroy;
      this.story.data.content.forEach((item, i) => {
        if (item.pivot_id === elem.pivot_id) {
          this.stampSquareIndex = i;
        }
        if (currentOrder === null) {
          currentOrder = elem.order;
        }
        if (item !== elem && item.order > currentOrder) {
          currentOrder = item.order;
          // need parse int to prevent string concatenation
          maxOrder = parseInt(currentOrder, 10) + 1;
        } else if (elem.order === currentOrder) {
          maxOrder = parseInt(currentOrder, 10);
        }
      });
      // add function call below to get xPoint and yPoint from it, this helps me to set coordinates property when scale and rotate stamp
      this.story.data.content[this.stampSquareIndex].order = maxOrder;
      if (this.scaleResizeAvailableIndex) {
        this.eventSelectStamp = this.scaleResizeAvailableIndex;
      }
      this.scaleResizeAvailableIndex = this.story.data.content[this.stampSquareIndex].pivot_id;
      // this add scale from computedProperties
      this.computedStamps.forEach((item) => {
        if (item.pivot_id === this.story.data.content[this.stampSquareIndex].pivot_id) {
          this.story.data.content[this.stampSquareIndex].scale = item.scale;
          item.order = maxOrder;
          this.currentStampType = item.type;
        }
      });
      this.$emit('current-stamp-index', this.stampSquareIndex);
      this.eventX = e.pageX;
      this.eventY = e.pageY;
    },
    moveEyesLips(e) {
      let that = this;
      draggableService.moveEyesLips(e, this.draggableVariables, this.stampSquareIndex, this.story, this.$refs.stamp, false, this.photoHeightAndWidth);
      // Adding coordinates for eyes and mouth
      // fixme: below code add left and top margins for array and that's how they save their position
      this.computedStamps.forEach(function (stamp, i) {
        if (stamp.pivot_id === that.draggableVariables.pivot_id) {
          that.computedStamps[i].leftTopStampPoint = {
            x: parseInt(that.draggableVariables.selected.style.left.replace('px', ''), 10),
            y: parseInt(that.draggableVariables.selected.style.top.replace('px', ''), 10)
          };
        }
      });
      let left = parseInt(this.draggableVariables.selected.style.left.replace('px', ''), 10);
      let top = parseInt(this.draggableVariables.selected.style.top.replace('px', ''), 10);
      this.story.data.content[this.stampSquareIndex].coordinates = {
        x: left,
        y: top
      };
      let deltaOffset = {
        x: (this.story.data.content[this.stampSquareIndex].coordinates.x - this.story.data.content[this.stampSquareIndex].initialCoordinatesSquare.x),
        y: (this.story.data.content[this.stampSquareIndex].coordinates.y - this.story.data.content[this.stampSquareIndex].initialCoordinatesSquare.y)
      };
      let stampCenterX = 0;
      let stampCenterY = 0;
      let rotatePoint = geometry.rotatePoint(deltaOffset.x, deltaOffset.y, stampCenterX, stampCenterY, this.story.data.content[this.stampSquareIndex].initialRotationSquare);
      deltaOffset.x = rotatePoint.x * (4 / 3) / this.story.data.content[this.stampSquareIndex].initialScaleSquare;
      deltaOffset.y = rotatePoint.y * (4 / 3) / this.story.data.content[this.stampSquareIndex].initialScaleSquare;
      this.story.data.content[this.stampSquareIndex].delta_offset = deltaOffset;
      this.story.data.content[this.stampSquareIndex].workingPreview = this.photoType;
    },
    selectFrameStamp(index, elem) {
      this.story.data.content.forEach((item, i) => {
        if (item.pivot_id === elem.pivot_id) {
          this.stampSquareIndex = i;
          this.currentStampType = item.type;
        }
      });
      this.scaleResizeAvailableIndex = this.story.data.content[this.stampSquareIndex].pivot_id;
      this.$emit('current-stamp-index', this.stampSquareIndex);
      console.log('stampSquareIndex from preview', this.stampSquareIndex);
    },
    // Draggable functions for images
    dragStart(e, index, elem, currentElemIndex) {
      let that = this;
      let maxOrder = null;
      let currentOrder = null;
      draggableService.dragStart(e, index, this.draggableVariables, currentElemIndex);
      console.log('this draggableVariables ', this.draggableVariables);
      document.addEventListener('mousemove', this.move);
      document.onmouseup = this.dragDestroy;
      this.story.data.content.forEach((item, i) => {
        if (item.pivot_id === elem.pivot_id) {
          this.stampSquareIndex = i;
        }
        if (currentOrder === null) {
          currentOrder = elem.order;
        }
        if (item !== elem && item.order > currentOrder) {
          currentOrder = item.order;
          // need parse int to prevent string concatenation
          // todo: add sorting method when saving
          maxOrder = parseInt(currentOrder, 10) + 1;
        } else if (elem.order === currentOrder) {
          maxOrder = parseInt(currentOrder, 10);
        }
      });
      this.story.data.content[this.stampSquareIndex].order = maxOrder;
      this.computedStamps.forEach(function (stampStatic, i, arr) {
        if (stampStatic.pivot_id === that.story.data.content[that.stampSquareIndex].pivot_id) {
          stampStatic.order = maxOrder;
          that.currentStampType = stampStatic.type;
        }
      });
      if (this.scaleResizeAvailableIndex) {
        this.eventSelectStamp = this.scaleResizeAvailableIndex;
      }
      this.scaleResizeAvailableIndex = this.story.data.content[this.stampSquareIndex].pivot_id;
      this.$emit('current-stamp-index', this.stampSquareIndex);
      this.eventX = e.pageX;
      this.eventY = e.pageY;
    },
    move(e) {
      let that = this;
      draggableService.move(e, this.draggableVariables, this.stampSquareIndex, this.story, this.$refs.static, false, this.photoHeightAndWidth);
      this.computedStamps.forEach(function (stamp) {
        if (stamp.pivot_id === that.story.data.content[that.stampSquareIndex].pivot_id) {
          stamp.staticOffset = that.story.data.content[that.stampSquareIndex].staticOffset;
        }
      });
    },
    dragDestroy() {
      draggableService.dragDestroy(this.draggableVariables);
      document.removeEventListener('mousemove', this.move);
      document.removeEventListener('mousemove', this.moveScaleResize);
      document.removeEventListener('mousemove', this.moveEyesLips);
      document.removeEventListener('mousemove', this.moveScaleResizeEyesLips);
    },
    initialLoad(stamps) {
      let that = this;
      that.computedStamps = [];
      stamps.forEach(function (stamp, i, stampArr) {
        if (stamp.type === 'eyes' || stamp.type === 'mouth') {
          console.log('stamp ', stamp);
          let returnedEyesLips = previewService.initialLoadEyesAndLips(stamp, that.faceLandmarks, that.imageDensity);
          stamp.initialRotationSquare = returnedEyesLips.initialRotation;
          stamp.initialScaleSquare = returnedEyesLips.initialScale;
          stamp.initialCoordinatesSquare = returnedEyesLips.initialCoordinates;
          that.addTransformationsToEyesAndLips(returnedEyesLips, stamp);
          // todo: fixed cannot read scale of null
          if (returnedEyesLips) {
            stamp.scale = returnedEyesLips.scale;
            stamp.rotation = -returnedEyesLips.rotate;
            returnedEyesLips.controlScale = geometry.calculateScaleForControls(returnedEyesLips.scale, that.controlSideLength);
            that.computedStamps.push(returnedEyesLips);
          }
        } else if (stamp.type === 'static') {
          that.computedStamps.push(previewService.createStaticStamp(stamp, that.photoHeightAndWidth, that.controlSideLength, that.imageDensity));
        } else if (stamp.type === 'frame') {
          that.computedStamps.push(previewService.createFrameStamp(stamp, that.imageDensity));
        }
      });
      console.log('computedStamps square ', that.computedStamps);
    },
    getCoordinatesEyesLips(computedEyesLips) {
      return {
        x: computedEyesLips.leftTopStampPoint.x,
        y: computedEyesLips.leftTopStampPoint.y
      };
    },
    addTransformationsToEyesAndLips(eyesOrLips, storyStamp) {
      if (storyStamp.delta_offset) {
        console.log(1);
        let stampCenterX = 0;
        let stampCenterY = 0;
        let rotatePoint = geometry.rotatePoint(storyStamp.delta_offset.x, storyStamp.delta_offset.y, stampCenterX, stampCenterY, 360 - eyesOrLips.initialRotation);
        eyesOrLips.leftTopStampPoint.x += (rotatePoint.x / (4 / 3)) * eyesOrLips.initialScale;
        eyesOrLips.leftTopStampPoint.y += (rotatePoint.y / (4 / 3)) * eyesOrLips.initialScale;
      }
      if (storyStamp.delta_scale) {
        console.log(2);
        eyesOrLips.scale *= storyStamp.delta_scale;
      }
      if (storyStamp.delta_rotation) {
        console.log(3);
        console.log(eyesOrLips.rotate);
        eyesOrLips.rotate -= storyStamp.delta_rotation;
        if (Math.abs(eyesOrLips.rotate) >= 360) eyesOrLips.rotate += 360;
        console.log(storyStamp.delta_rotation);
      }
    },
    preventDrag(e) {
      e.preventDefault();
    },
    showDataForStack(event, stamp) {
      let returnedData = previewService.stampStackPopUp(event, stamp, this.eventSelectStamp, this.scaleResizeAvailableIndex, this.eventX, this.eventY, this.initialStampSideLength, this.computedStamps, this.currentStampType, this.story, this.stampSquareIndex);
      this.scaleResizeAvailableIndex = returnedData.scaleResizeAvailableIndex;
      this.currentStampType = returnedData.currentStampType;
      this.$emit('current-stamp-index', returnedData.stampIndex);
    }
  },
  watch: {
    startDownload: {
      handler() {
        let that = this;
        previewService.createDownloadImageData(that, that.initialStampSideLength, that.computedStamps);
      }
    },
    staticStampChanges: {
      handler() {
        let that = this;
        that.story.data.content.forEach(function (storyStamp) {
          that.computedStamps.forEach(function (stamp, i, arr) {
            if (stamp.pivot_id === that.staticStampChanges.pivot_id && stamp.pivot_id === storyStamp.pivot_id) {
              stamp.scale = that.staticStampChanges.scale;
              stamp.rotate = -that.staticStampChanges.rotate;
              storyStamp.scale = that.staticStampChanges.scale;
              storyStamp.rotation = -that.staticStampChanges.rotate;
            }
          });
        });
      },
      deep: true
    },
    // Watching for eyes/mouth type changing
    changedType: {
      handler() {
        if (!this.changeShape) {
          let that = this;
          let stampNotExist = true;
          let computedEyesLips = that.computedStamps;
          if (that.changedType.type === 'eyes' || that.changedType.type === 'mouth') {
            if (computedEyesLips.length > 0) {
              for (let i = computedEyesLips.length - 1; i >= 0; i -= 1) {
                if (computedEyesLips[i].pivot_id === that.changedType.pivot_id) {
                  computedEyesLips.splice(i, 1);
                  let returnedEysAndLips = previewService.initialLoadEyesAndLips(that.changedType, that.faceLandmarks, that.imageDensity);
                  if (that.story.data.content && that.stampSquareIndex && (that.changedType.type === 'eyes' || that.changedType.type === 'mouth')) {
                    that.story.data.content[that.stampSquareIndex].coordinates = that.getCoordinatesEyesLips(returnedEysAndLips);
                    that.story.data.content[that.stampSquareIndex].initialCoordinatesSquare = that.getCoordinatesEyesLips(returnedEysAndLips);
                  }
                  computedEyesLips.push(returnedEysAndLips);
                  stampNotExist = false;
                } else if (i === computedEyesLips.length - 1 && stampNotExist) {
                  let returnedEysAndLips = previewService.initialLoadEyesAndLips(that.changedType, that.faceLandmarks, that.imageDensity);
                  if (that.story.data.content && that.stampSquareIndex && (that.changedType.type === 'eyes' || that.changedType.type === 'mouth')) {
                    that.story.data.content[that.stampSquareIndex].coordinates = that.getCoordinatesEyesLips(returnedEysAndLips);
                    that.story.data.content[that.stampSquareIndex].initialCoordinatesSquare = that.getCoordinatesEyesLips(returnedEysAndLips);
                  }
                  computedEyesLips.push(returnedEysAndLips);
                }
              }
            } else {
              let returnedEysAndLips = previewService.initialLoadEyesAndLips(that.changedType, that.faceLandmarks, that.imageDensity);
              if (that.story.data.content && that.stampSquareIndex && (that.changedType.type === 'eyes' || that.changedType.type === 'mouth')) {
                that.story.data.content[that.stampSquareIndex].coordinates = that.getCoordinatesEyesLips(returnedEysAndLips);
                that.story.data.content[that.stampSquareIndex].initialCoordinatesSquare = that.getCoordinatesEyesLips(returnedEysAndLips);
              }
              computedEyesLips.push(returnedEysAndLips);
            }
          } else if (that.changedType.type === 'static' || that.changedType.type === 'frame') {
            for (let i = computedEyesLips.length - 1; i >= 0; i -= 1) {
              if (computedEyesLips[i].pivot_id && computedEyesLips[i].pivot_id === that.changedType.pivot_id) {
                computedEyesLips.splice(i, 1);
              }
            }
          }
          if (that.changedType.type === 'eyes') {
            that.currentStampType = 'eyes';
          } else if (that.changedType.type === 'mouth') {
            that.currentStampType = 'mouth';
          } else if (that.changedType.type === 'static') {
            that.currentStampType = 'static';
          } else if (that.changedType.type === 'frame') {
            that.currentStampType = 'frame';
          }
          that.story.data.content[that.stampSquareIndex].delta_offset = null;
          that.story.data.content[that.stampSquareIndex].delta_rotation = null;
          that.story.data.content[that.stampSquareIndex].delta_scale = null;
        }
        // This cares about deleting and creating static and frame stamps
        this.initialLoad(this.story.data.content);
      }
    },
    // Watching for story object and dynamically
    // todo: rewrite in new way
    framePositionChanged: {
      handler() {
        this.initialLoad(this.story.data.content);
      }
    },
    refreshComponents: {
      handler() {
        this.scaleResizeAvailableIndex = null;
        this.currentStampType = null;
        this.eventSelectStamp = null;
        this.initialLoad(this.story.data.content);
        this.faceFromServer = {
          eyes: new classes.Eyes(this.faceLandmarks.eyes[0], this.faceLandmarks.eyes[1]),
          mouth: new classes.Mouth(this.faceLandmarks.mouth[0], this.faceLandmarks.mouth[1])
        };
        console.log('refreshComponents finished ');
      }
    },
    // fixme: This hack watcher needed cuz story deep watch can't detect changes in points object, don't know why
    changeShape: {
      handler() {
        // condition renders only on current preview
        if (!this.changeShape) {
          // fixme: work only with v-show on image preview that's why I add two strings below
          this.photoHeightAndWidth.height = this.$refs.photo.style.height.replace('px', '');
          this.photoHeightAndWidth.width = this.$refs.photo.style.width.replace('px', '');
          this.initialLoad(this.story.data.content);
          this.faceFromServer = {
            eyes: new classes.Eyes(this.faceLandmarks.eyes[0], this.faceLandmarks.eyes[1]),
            mouth: new classes.Mouth(this.faceLandmarks.mouth[0], this.faceLandmarks.mouth[1])
          };
        }
      }
    }
  },
  mounted() {
    // doesn't work without window load listener cuz this.ref.photo.height doesn't exist
    window.addEventListener('load', () => {
      this.photoHeightAndWidth.height = this.$refs.photo.style.height.replace('px', '');
      this.photoHeightAndWidth.width = this.$refs.photo.style.width.replace('px', '');
    });
  },
// todo: test if destroy works fine
  destroy() {
    window.removeEventListener('load', function () {
      // console.log('listener should be removed');
    });
  }
});



// WEBPACK FOOTER //
// ./src/js/visual-preview-square-compontent.js